import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { AuthService } from 'app/providers/bridge-api/auth.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { Group, GroupService } from '../../../../providers/semantria-api/group.service';
import {
  SemantriaUser,
  SemantriaUsersService,
} from '../../../../providers/semantria-api/semantria-users.service';
import { AlertService } from '../../../../services/alert.service';
import { DialogService } from '../../../../services/dialog.service';
import { PermissionTableComponent } from './permission-table.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-group-permission-table',
  templateUrl: './permission-table.component.html',
  styleUrls: ['./permission-table.component.scss'],
  standalone: false,
})
export class GroupPermissionTableComponent
  extends PermissionTableComponent<Group, SemantriaUser>
  implements OnInit, OnChanges, AfterViewInit
{
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  constructor(
    protected groupService: GroupService,
    protected userService: SemantriaUsersService,
    protected dialogService: DialogService,
    protected authService: AuthService,
    protected alertService: AlertService,
    protected changeDetector: ChangeDetectorRef,
    protected translocoService: TranslocoService
  ) {
    super(
      groupService,
      userService,
      dialogService,
      authService,
      alertService,
      changeDetector,
      translocoService
    );

    this.itemType = 'users';
    this.sortFnFactory = (sort, direction) => (u1: SemantriaUser, u2: SemantriaUser) => {
      switch (sort.active) {
        case 'name':
          let ret = this.propSort(u1, u2, 'first_name', direction);

          if (!ret) {
            ret = this.propSort(u1, u2, 'last_name', direction);
          }

          if (!ret) {
            ret = this.propSort(u1, u2, 'login', direction);
          }

          return ret;
        case 'executive':
        case 'read':
        case 'all':
          return u1.email.localeCompare(u2.email) * direction;
        default:
          return 0;
      }
    };
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    this.itemCount = this.parent?.members.length ?? 0;
  }

  getName(item) {
    if (!item.first_name && !item.last_name) {
      return item.login;
    }

    return `${item.first_name || ''} ${item.last_name || ''}`;
  }

  getEmail(item: SemantriaUser) {
    return item.email;
  }

  getId(item: SemantriaUser) {
    return item.user_id;
  }

  getUser(item: SemantriaUser) {
    return item;
  }

  getUserId(item: SemantriaUser) {
    return item.user_id;
  }

  getGroupId() {
    return this.parent.group_id;
  }
}
